<template>
  <div class="cmp-contacts-contacts-contact_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddContactClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search">
        <InputField
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <DTIconButton
          :classNames="'search--advanced'"
          :text="$t('advanced_search')"
          :style="{
            minWidth: '148px',
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
        <!-- <div class="search-config--container">
          <div class="search-config">
            <SearchConBadge
              v-for="sconKey of filteredAdvancedSearchConfigKeys"
              :key="sconKey"
              v-bind="searchConfigKey(sconKey)"
              @delete="onSearchConDelete"
            />
          </div>
        </div> -->
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        id="contacts-contacts-contact_list"
        class="h1"
        :config="tableConfig"
        :headers="contactHeaders"
        :items="tableList"
        @scrollnext="onContactNext"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
            @click="onContactClicked(item)"
            :title="'Click to see Contact Details'"
          >
            <td v-bind="tdcon('name')">
              <div class="name-email">
                <div class="name">{{ getName(item) }}</div>
                <div class="email">
                  <a v-if="item['email1']" :href="`mailto:${item['email1']}`">
                    <img
                      src="static/icons/email/email-grey.svg"
                      @click.stop
                      class="dt-icon"
                      alt
                    />
                  </a>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('country')">
              <span>{{ item["country"] }}</span>
            </td>
            <td v-bind="tdcon('city')">
              <span>{{ item["city"] }}</span>
            </td>
            <td v-bind="tdcon('phone')">
              <div>
                <div class="phone-no">
                  <span>{{ item["phone1"] }}</span>
                </div>
                <div class="phone-icon">
                  <a :href="`tel:${item['phone1']}`">
                    <img
                      src="static/icons/phone.svg"
                      @click.stop
                      class="dt-icon"
                      alt
                    />
                  </a>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="
                  (e) =>
                    onDeleteContact({
                      contact_id: item.contact_id,
                      name: getName(item),
                    })
                "
                class="dt-icon v5 s2"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <!-- <v-navigation-drawer
        v-bind="defaultConfig"
        :value="contactDetailsFlag"
        touchless
      >
      <ContactSidewindow
        :selectedContact="selectedContact"
        @closeContactSidewindow="onCloseContactSidewindow"
        @fetch="onContactFetch"
      ></ContactSidewindow>

    </v-navigation-drawer>-->
    <Sidewindow
      :navConfig="defaultConfig"
      :value="contactDetailsFlag"
      @closed="onCloseContactSidewindow"
    >
      <ContactSidewindow
        :selectedContact="selectedContact"
        @fetch="onContactFetch"
        @delete="onDeleteContact"
      ></ContactSidewindow>
    </Sidewindow>

    <template v-if="advancedSearchModalContainer">
      <v-dialog v-model="advancedSearchModal" persistent width="580">
        <AdvancedSearch
          :groupsTV="groupsTV"
          :countriesTV="countriesTV"
          :searchConfig="searchConfig"
          @search="onAdvancedSearch"
          @export="onAdvancedSearchExport"
          @create_group="onAdvancedSearchCreateGroup"
          @cancelled="onAdvancedSearchCancelled"
        />
      </v-dialog>
    </template>
  </div>
</template>

<script>
import { ContactStoreNamespace as storeNS } from "../../store";
import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../../store/types";
import {
  contactListLDTRoutes,
  getContactDetailsSelectable,
} from "../../router/routes";
import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";
import { SelectResults } from "../../../booking/router/router";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import ContactSidewindow from "./contact-sidewindow";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";
import AdvancedSearch, { AdvancedSearchConfigKeys } from "./advanced-search";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import { ContactsService } from "../../services/contacts.service";
import { createCountriesTV } from "../../../../models/country.model";
import {
  confirmDelete,
  confirmWarning,
} from "../../../../dt-plugins/confirmation/confirmation-common";
import { ContactFuncs, createContact } from "../../models/contacts.model";
import { showNotification } from "../../../../dt-plugins/notification/notification.service";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { DTIconButton } from "../../../../plugins/button/button";
import SearchConBadge from "../../../../dt-plugins/advanced-search/search-con-badge";
import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
import { range } from "ramda";
import {
  findADVSearchOmitFromKey,
  isActivatedSearchKey,
  SearchActivatedSearchKeyLabelMap,
} from "./advanced-search.vue";
import { mapActionObject } from "../../../../store/global";
import { actions } from "../../store/actions";
import { isNotEmpty } from 'ramda-adjunct';

const LDTConfig = {
  entityName: "contact",
  ldtRoutes: contactListLDTRoutes,
  detailsSelectableFunction: getContactDetailsSelectable,
  primaryKey: "contact_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.ContactDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.ContactDetails.FETCH.SINGLE,
};

let ContactList;

export default {
  components: {
    ContactSidewindow,
    NTable,
    InputField,
    AdvancedSearch,

    DTIconButton,
    SearchConBadge,
  },
  mounted: async function () {
    // console.log("ContactList mounted fetchContactsList");
    // this.fetchContactsList();
    ContactList = this;

    this.$subscribeTo(
      this.subjectSearchSubject$
        .asObservable()
        .pipe(distinctUntilChanged(), debounceTime(500)),
      (searchString) => {
        if (searchString.length > 0) {
          // this.searchContacts(searchString);
          this.$router.push({
            ...this.$route,
            query: {
              search: searchString,
            },
          });
          // this.fetchContactsList("search", searchString);
        } else {
          console.error("searchString fetchContactsList", searchString);
          this.fetchContactsList();
        }
      }
    );

    const res = await ContactsService.getAdvancedForm();
    this.countries = res.data.countries;
    this.groups = res.data.groups;
  },
  data: () => ({
    individualHeaders: [
      {
        value: "name",
        text: "Individuals",
        tkey: "start_date",
      },
      { value: "country", text: "Country", tkey: "artist" },
      { value: "city", text: "City", tkey: "status" },
      { value: "phone", text: "Phone", tkey: "venue" },
      { value: "mail", text: "Mail", tkey: "venue" },
      { value: "options", text: "", tkey: "city" },
    ],
    defaultConfig: defaultConfig,
    getContactDetailsSelectable: getContactDetailsSelectable,

    countries: [],
    groups: [],

    startRow: 0,
    loadingFlag: true,

    subjectSearchSubject$: new Subject(),
    searchString: "",

    advancedSearchModal: null,
    advancedSearchModalContainer: null,

    selectedClickedContact: null,

    AdvancedSearchConfigKeys: AdvancedSearchConfigKeys,
  }),
  mixins: [createLDTHost(LDTConfig), createModalMixin("advancedSearch")],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        let searchConfig = {};
        let queryChanged = false;
        let changedQueries = [];

        console.log("ContactList $route", {
          to: to,
          from: from,
        });

        if (!from && !isNotEmpty(to.query)) {
          this.fetchContactsList();
          return;
        }

        for (const key of Object.keys(to.query)) {
          if (
            (!from && to?.query) ||
            (from && to?.query?.[key] !== from?.query?.[key])
          ) {
            queryChanged = true;
            changedQueries = [...changedQueries, key];
            searchConfig = {
              ...searchConfig,
              [key]: to.query[key],
            };
          }
        }
        const advancedSearchKeys = [
          "name",
          "city",
          "country",
          "postalcode",
          "address",
          "region",
          "email",
          "group_id",
        ];
        // If queryChanged and changedQueries contains any of the keys in AdvancedSearchKeys

        console.log("queryChanged", queryChanged, changedQueries, {
          csad: changedQueries.some((e) => advancedSearchKeys.includes(e)),
        });

        if (queryChanged && to.query?.search?.length > 0) {
          this.searchString = to.query.search;
          console.log("searchQuery fetchContactsList", this.searchString);
          this.fetchContactsList("search", to.query.search);
          return;
        }

        if (
          queryChanged &&
          changedQueries.some((e) => advancedSearchKeys.includes(e))
        ) {
          console.log("advanced_search searchConfig", searchConfig);
          searchConfig = advancedSearchKeys.reduce((acc, key) => {
            return {
              ...acc,
              [key]: searchConfig[key] ? searchConfig[key] : "",
            };
          }, {});
          console.log("advanced_search fetchContactsList", searchConfig);
          this.fetchContactsList("advanced_search", searchConfig);
        }


      },
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      contactsData: "contactsData",
      selectedContact: "selectedContact",
      searchConfig: "searchConfig",
    }),
    contactHeaders: function () {
      return [
        createTableHeader("name"),
        createTableHeader("country"),
        createTableHeader("city"),
        createTableHeader("phone"),
        createTableHeader("options", { text: false, mw: 35 }),
      ];
    },
    contactDetailsFlag: function () {
      return childOfOrEqualDetails(contactListLDTRoutes, this.$route);
    },
    list: function () {
      return this.contactsData.contacts;
    },
    tableList: function () {
      return this.loadingFlag
        ? range(0, 2).map(createContact)
        : this.contactsData.contacts;
    },
    countriesTV: function () {
      return createCountriesTV(this.countries);
    },
    groupsTV: function () {
      return this.groups.map((g) => {
        return {
          text: g.group_name,
          value: g.group_id,
        };
      });
    },

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },

    isSearchActivated: function () {
      return Object.values(this.searchConfig).length > 0;
    },
    searchCountry: function () {
      return this.searchConfig.country ? this.searchConfig.country : false;
    },
    isSearchCountryOmitted: function () {
      return this.searchConfig.country_omit &&
        this.searchConfig.country_omit.length > 0
        ? true
        : false;
    },
    searchCity: function () {
      return this.searchConfig.city ? this.searchConfig.city : false;
    },

    filteredAdvancedSearchConfigKeys: function () {
      return AdvancedSearchConfigKeys.filter((e) => this.searchConfigValue(e));
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.ContactsData.FETCH.ALL]: ActionTypes.ContactsData.FETCH.ALL,
      [ActionTypes.ContactsData.FETCH.MULTIPLE]:
        ActionTypes.ContactsData.FETCH.MULTIPLE,
      [ActionTypes.SEARCH_CONTACTS]: ActionTypes.SEARCH_CONTACTS,
      [ActionTypes.ADVANCED_SEARCH_CONTACTS]:
        ActionTypes.ADVANCED_SEARCH_CONTACTS,
      [ActionTypes.SET_CONTACT_SEARCH_CONFIG]:
        ActionTypes.SET_CONTACT_SEARCH_CONFIG,
      [ActionTypes.ADVANCED_SEARCH_CREATE_GROUP]:
        ActionTypes.ADVANCED_SEARCH_CREATE_GROUP,
      // [ActionTypes.SelectedContact.SET.SINGLE]: ActionTypes.SelectedContact.SET.SINGLE,
    }),
    ...mapActionObject(storeNS, actions),
    onContactClicked: function (contact) {
      this.selectedClickedContact = contact;
      onDetailsRowClicked(this.$router, contact, contactListLDTRoutes);
    },
    getName: ContactFuncs.getName,
    onDeleteContact: async function ({ contact_id, name }) {
      // Implement Contact Delete Logic
      // deleteContact(contact.contact_id, ContactFuncs.getName(contact));

      const invoiceRelation = await ContactsService.checkInvoiceRelation({
        contact_id,
      });
      // console.log(invoiceRelation.data.has_invoice_relation);
      if (invoiceRelation.data.has_invoice_relation === "no") {
        const confirmationResult = await confirmDelete("Contact", name);
        if (confirmationResult === "OK") {
          this[ActionTypes.ContactsData.DELETE.SINGLE]({ contact_id });

          // ContactsService.removeCompanyContact({
          //   contact_id: contact_id,
          // }).then((res) => {
          //   this.$router.push({
          //     name: contactListLDTRoutes.names.list,
          //   });
          //   this.fetchList();
          // });
        }
      } else {
        const confirmationResult = await ConfirmationService.createP({
          body: "This Contact can not be deleted. It is related to an invoice",
          width: 376,
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });
        // await confirmWarning(
        //   "This Contact can not be deleted. It is related to an invoice"
        // );
      }
    },
    onCloseContactSidewindow: function () {
      this.selectedClickedContact = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: contactListLDTRoutes.names.list,
        });
      });
      // this.$router.push({
      //   name: contactListLDTRoutes.names.list
      // });
    },
    onContactNext: function (scrollPercent) {
      if (this.searchString.length == 0 && !this.isSearchActivated) {
        // this.fetchContactsNext();
        this.fetchContactsList("next");
      }
    },
    fetchContactsList: async function (type = "init", payload) {
      console.log("fetchContactsList", type, payload);
      if (type != "next") {
        this.loadingFlag = true;
      }

      if (type == "init") {
        this.startRow = 0;
        await this[ActionTypes.ContactsData.FETCH.ALL]({
          startRow: this.startRow,
        });
      } else if (type == "next") {
        if (this.contactsData.startRow == this.startRow) {
          this.startRow += 100;
          await this[ActionTypes.ContactsData.FETCH.MULTIPLE]({
            startRow: this.startRow,
          });
        }
      } else if (type == "search") {
        await this[ActionTypes.SEARCH_CONTACTS]({
          key: payload,
        });
      } else if (type == "advanced_search") {
        await this[ActionTypes.ADVANCED_SEARCH_CONTACTS](payload);
      }

      this.loadingFlag = false;
    },
    fetchList: function () {
      console.log("fetchList");
      if (this.searchString && this.searchString.length > 0) {
        this.fetchContactsList("search", this.searchString);
      } else {
        this.fetchContactsList();
      }
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.subjectSearchSubject$.next(this.searchString);
    },
    onAddContactClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact",
        },
      });
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    onAdvancedSearchCancelled: function (event) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAdvancedSearch: function (searchConfig) {
      // Update Route Query with searchConfig

      // this.fetchContactsList("advanced_search", searchConfig);
      this.onAdvancedSearchCancelled();

      this.$router.push({
        ...this.$route,
        query: {
          ...searchConfig,
        },
      });

      console.log("searchConfig", searchConfig);
    },
    onAdvancedSearchExport: function (searchConfig) {
      const popupURL = ContactsService.exportAdvancedSearchURL(searchConfig);

      window.open(popupURL, "Advanced Search Result", "height=200,width=150");
      this.onAdvancedSearchCancelled();
    },
    onAdvancedSearchCreateGroup: function (searchConfig) {
      this[ActionTypes.ADVANCED_SEARCH_CREATE_GROUP](searchConfig);
    },
    onContactFetch: function () {
      console.log("onContactFetch");
      this.fetchContactsList();
    },
    selectedRow: function (contact) {
      return (
        this.selectedClickedContact &&
        this.selectedClickedContact["contact_id"] === contact["contact_id"]
      );
    },
    isSearchKeyOmitted: function (key) {
      return key == "group_id"
        ? this.searchConfig[`group_omit_id`] &&
          this.searchConfig[`group_omit_id`].length > 0
          ? true
          : false
        : this.searchConfig[`${key}_omit`] &&
          this.searchConfig[`${key}_omit`].length > 0
        ? true
        : false;
    },
    searchConfigKey: function (key) {
      return {
        value: this.searchConfigValue(key),
        searchKey: key,
        isOmitted: this.isSearchKeyOmitted(key),
      };
    },
    onSearchConDelete: function (key) {
      const omitKey = findADVSearchOmitFromKey(key);
      const sConf = {
        ...this.searchConfig,
        [key]: "",
        ...(omitKey ? { [omitKey]: "" } : {}),
      };

      if (isActivatedSearchKey(key)) {
        delete sConf[key];
      }

      if (Object.values(sConf).every((e) => !e)) {
        this[ActionTypes.SET_CONTACT_SEARCH_CONFIG](sConf);
        this.fetchContactsList();
      } else {
        this.onAdvancedSearch(sConf);
      }
    },
    searchConfigValue: function (key) {
      if (key === "group_id") {
        const group_id = this.searchConfig[key];

        const group = this.groupsTV.find((e) => e.value == group_id);
        return group_id && group ? group.text : false;
      }
      if (isActivatedSearchKey(key)) {
        return this.searchConfig[key]
          ? SearchActivatedSearchKeyLabelMap[key]
            ? SearchActivatedSearchKeyLabelMap[key]
            : key
          : false;
      }
      return this.searchConfig[key] ? this.searchConfig[key] : false;
    },

    // MARK: Methods
  },
};

export const deleteContact = async (contact_id, name) => {
  console.log(ContactList);
  const invoiceRelation = await ContactsService.checkInvoiceRelation({
    contact_id,
  });
  // console.log(invoiceRelation.data.has_invoice_relation);
  if (invoiceRelation.data.has_invoice_relation == "no") {
    const confirmationResult = await confirmDelete("Contact", name);
    if (confirmationResult == "OK") {
      ContactsService.removeCompanyContact({
        contact_id: contact_id,
      }).then((res) => {
        ContactList.$router.push({
          name: contactListLDTRoutes.names.list,
        });
        ContactList.fetchList();
      });
    }
  } else {
    const confirmationResult = await ConfirmationService.createP({
      body: "This Contact can not be deleted. It is related to an invoice",
      width: 376,
      results: [
        createConfirmResult({
          value: "ok",
          text: "OK",
          classes: ["v1 s7"],
        }),
      ],
    });
    // await confirmWarning(
    //   "This Contact can not be deleted. It is related to an invoice"
    // );
  }
};
</script>

<style lang="scss">
.cmp-contacts-contacts-contact_list {
  .dt-page--body {
    --offset: 120px;
  }
  .dt-page--body > .dt-ntable {
    td:first-child {
      font-weight: 700;
      color: black;
    }

    td {
      .name-email {
        display: flex;
        height: 100%;

        .name,
        .email {
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .email {
          display: flex;
          justify-content: center;
          text-align: center;
        }

        .name,
        .email {
          flex: 1;
        }
      }
    }
  }

  td .phone-icon {
    display: none;
  }
  td .phone-no {
    display: inherit;
  }

  @media (min-width: 1281px) {
  }
  @media (min-width: 1025px) and (max-width: 1280px) {
  }
  @media (min-width: 768px) {
    .dt-page--top-bar {
      .input-field-container {
        max-width: 128px;
      }
      .search--advanced {
        max-width: 148px;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
  @media (min-width: 481px) and (max-width: 767px) {
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .dt-page--top-bar {
      .right-space {
        flex: 10;
      }
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .dt-page--top-bar > div {
      margin: 0 0 0 10px;
    }
    .dt-ntable {
      td .email {
        flex: 0.5 !important;
      }
      td .phone-no {
        display: none;
      }
      td .phone-icon {
        display: inherit;
      }
      th:nth-child(2),
      td:nth-child(2) {
        display: none;
      }

      th:nth-child(3),
      td:nth-child(3) {
        flex: 0.4;
      }

      th:nth-child(4),
      td:nth-child(4) {
        flex: 0.3;
        display: flex;
        justify-content: center;
        .phone-icon {
          margin-left: 10px;
        }
      }
    }
  }
  @media (min-width: 320px) and (max-width: 375px) {
    .dt-page--top-bar .search .search--advanced span {
      margin-right: 7px;
    }
    button.search--advanced {
      flex: 1.5 !important;
    }
  }
}

.dt-page--top-bar {
  .search {
    flex: 12;
    display: flex;
    align-items: center;

    .input-field-container {
      flex: 1;
    }
    .search--advanced {
      flex: 1;
    }
  }
  .right-space {
    flex: 26;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .right-space {
      flex: 0;
    }
  }
}
</style>